module.exports = __webpack_public_path__ + "static/media/yay.e82a2575.wav";